module.exports = __webpack_public_path__ + "static/media/placeholder.f193e749.svg";